<template>
    <div id="edit-site-dialog-component">
        <v-dialog v-model="is_open_edit_site_dialog_open" max-width="500">
            <v-card>
                <v-form>
                    <v-card-title>
                        <p class="text-uppercase font-weight-bold">
                            {{ $t('global_equipment.edit_site') }}
                        </p>
                    </v-card-title>

                    <v-card-text>
                        <p class="mb-0">{{ $t('asset_localisation_widget_component.address') }}</p>
                        <GmapAutocomplete
                            ref="autocomplete"
                            :types="['geocode']"
                            class="autocomplete-input"
                            @input="selected_place = null"
                            @place_changed="setGoogleAddress"
                        />

                        <v-alert v-if="is_bad_address" type="error">
                            {{ $t('bad_address') }}
                        </v-alert>
                    </v-card-text>

                    <v-card-actions class="justify-end">
                        <v-btn text @click="is_open_edit_site_dialog_open = false">
                            <span class="font-weight-bold">{{ $t('global.cancel') }}</span>
                        </v-btn>

                        <v-btn
                            :disabled="!selected_place"
                            :loading="is_loading"
                            class="font-weight-bold btn-secondary-loader"
                            color="secondary"
                            text
                            @click="updateSite()"
                        >
                            <span class="secondary--text font-weight-bold">{{ $t('global.validate') }}</span>
                        </v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import domicileRepository from '@/repositories/DomicileRepository'
import displayHuman from '@/mixin/displayHuman'

export default {
    mixins: [displayHuman],
    name: 'EditSiteDialogComponent',
    data() {
        return {
            is_open_edit_site_dialog_open: false,
            site: {},
            selected_place: null,
            is_loading: false,
            is_bad_address: false,
        }
    },
    methods: {
        openEditSiteDialog(site) {
            this.is_open_edit_site_dialog_open = true
            this.site = { ...site }
            this.$nextTick(() => {
                this.$refs.autocomplete.$refs.input.value = this.displayToHumanDomicileAddress(this.site)
            })
            this.selected_place = null
        },
        setGoogleAddress(place) {
            this.selected_place = place
            if (place && place.formatted_address) {
                this.site.address = place.formatted_address
            }
        },
        isPlaceComplete(place) {
            let count = 0
            place.address_components.forEach((component) => {
                if (
                    component.types.includes('street_number') ||
                    component.types.includes('route') ||
                    component.types.includes('locality') ||
                    component.types.includes('postal_town') || //English case
                    component.types.includes('country') ||
                    component.types.includes('postal_code')
                ) {
                    count++
                }
            })
            return count >= 5
        },
        updateSite() {
            const place = this.selected_place
            if (!place || !place.address_components) {
                this.is_bad_address = true
                return
            }
            this.is_bad_address = false

            let site = {
                id_google_place: place.place_id,
                street_number: '',
                address: '',
                city: '',
                postal_code: '',
                country: '',
                country_code: '',
                plus_code: '',
                address2: !place.formatted_address.includes(place.name) ? place.name : '',
                latitude: place.geometry?.location?.lat() || '',
                longitude: place.geometry?.location?.lng() || '',
            }

            place.address_components?.forEach((component) => {
                if (component.types.includes('street_number')) {
                    site.street_number = component.long_name
                } else if (component.types.includes('route')) {
                    site.address = component.long_name
                } else if (component.types.includes('locality')) {
                    site.city = component.long_name
                } else if (component.types.includes('postal_town') && site.city === '') {
                    //English case
                    site.city = component.long_name
                } else if (component.types.includes('postal_code')) {
                    site.postal_code = component.long_name
                } else if (component.types.includes('country')) {
                    site.country = component.long_name
                    site.country_code = component.short_name
                } else if (component.types.includes('plus_code')) {
                    site.plus_code = component.long_name
                }
            })

            if (!this.isPlaceComplete(place)) {
                site.address = place.formatted_address.substring(0, place.formatted_address.indexOf(','))
            }

            site.route = site.address
            site.locality = site.city

            this.is_loading = true

            domicileRepository
                .postUpdateDomicile(this.site.id_domicile, site)
                .then(() => {
                    this.showSnackbar('success', this.$t('global.updated'))
                    this.$emit('updated:site', this.site)
                    this.is_open_edit_site_dialog_open = false
                })
                .catch((error) => {
                    this.manageError(error)
                })
                .finally(() => {
                    this.is_loading = false
                })
        },
    },
}
</script>
<style>
.autocomplete-input {
    margin-bottom: 4px;
    height: 52px;
    width: 100%;
    border-radius: 4px 4px 0 0;
    outline: none;
    border-bottom: 1px solid #e0e0e0;
    padding: 0 16px;
    font-size: 16px;
    font-weight: 500;
    background: #f6f6f6;
}
</style>
